import React from 'react'

export const Close = ({ className, onClick = null  }) => (
  <div className={className} onClick={onClick}>
    <svg width="29" height="29" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" stroke="#44423E" fill="none" strokeLinecap="round">
        <path d="M.571.571L28.43 28.43M28.429.571L.57 28.43" />
      </g>
    </svg>
  </div>
)

export const CloseSmall = ({ className, onClick = null }) => (
  <div className={className} onClick={onClick}>
    <svg width="18px" height="18px" xmlns="http://www.w3.org/2000/svg">
      <rect
        id="Rectangle-5-Copy-3"
        fill="#eae8e4"
        transform="translate(9.088835, 10.000000) rotate(-45.000000) translate(-9.088835, -10.000000) "
        x="-3.16116524"
        y="9.5"
        width="24.5"
        height="1"
        rx="0.5"
      ></rect>
      <rect
        id="Rectangle-5-Copy-3"
        fill="#eae8e4"
        transform="translate(9.088835, 10.000000) rotate(-315.000000) translate(-9.088835, -10.000000) "
        x="-3.16116524"
        y="9.5"
        width="24.5"
        height="1"
        rx="0.5"
      ></rect>
    </svg>
  </div>
)

export const EyeIcon = ({isRed}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      {isRed ? (
        <path
          fill="#646771"
          d="M9.876 7.421l2.306 2.328v-.117a2.22 2.22 0 00-.64-1.563A2.168 2.168 0 0010 7.42h-.124zm-3.127.59l1.127 1.142c-.036.154-.058.31-.058.479 0 .586.23 1.148.64 1.563.408.414.963.647 1.542.647.16 0 .32-.022.473-.059l1.127 1.142a3.568 3.568 0 01-1.6.39 3.61 3.61 0 01-2.571-1.078 3.709 3.709 0 01-1.065-2.605c0-.583.145-1.128.385-1.621zM2.727 3.936l1.658 1.68.328.331A8.71 8.71 0 002 9.632c1.258 3.234 4.364 5.526 8 5.526a8.467 8.467 0 003.185-.62l.313.31L15.622 17l.924-.936L3.65 3M10 5.947c.964 0 1.89.389 2.571 1.08a3.71 3.71 0 011.065 2.605c0 .471-.094.928-.261 1.34l2.13 2.16A8.724 8.724 0 0018 9.632c-1.258-3.235-4.364-5.527-8-5.527a8.515 8.515 0 00-2.91.516l1.58 1.584A3.63 3.63 0 0110 5.947z"
        ></path>
      ) : (
        <path
        className={isRed ? 'red-eye-icon' : ''}
        fill="#646771"
        d="M10 7.6c-.651 0-1.275.253-1.736.703-.46.45-.719 1.06-.719 1.697 0 .636.26 1.247.72 1.697.46.45 1.084.703 1.735.703s1.275-.253 1.736-.703c.46-.45.718-1.06.718-1.697s-.258-1.247-.718-1.697A2.483 2.483 0 0010 7.6zm0 6.4a4.138 4.138 0 01-2.893-1.172A3.955 3.955 0 015.91 10c0-1.06.431-2.078 1.198-2.828A4.139 4.139 0 0110 6c1.085 0 2.126.421 2.893 1.172A3.955 3.955 0 0114.09 10c0 1.06-.431 2.078-1.198 2.828A4.138 4.138 0 0110 14zm0-10c-4.09 0-7.585 2.488-9 6 1.415 3.512 4.91 6 9 6s7.584-2.488 9-6c-1.416-3.512-4.91-6-9-6z"
      ></path>
      )
      }
    </svg>
  );
}

export const DropDownArrow = (props) => {
  return (
    <svg {...props} style={{position: 'absolute', right: '24px', top: '45%'}} xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none">
      <path
        fill="currentColor"
        d="M13.57 1.49A.75.75 0 1012.43.5l1.14.98zM7 8l-.57.49a.75.75 0 001.14 0L7 8zM1.57.51a.75.75 0 10-1.14.98L1.57.5zm10.86 0l-6 7 1.14.98 6-7L12.43.5zm-4.86 7l-6-7-1.14.98 6 7 1.14-.98z"
      ></path>
    </svg>
  );
}
